<template>
  <!-- start 打字通首页 -->
  <div class="all-page-style">
    <CustomHead
      @getUserInfo="getUserInfo"
      ref="customHead"
      @wxLoginOk="wxLoginOks"
      @withdrawAccount="withdrawAccount"
    ></CustomHead>
    <div class="all-page-content">
      <div class="home" :style="{ transform: 'scale(' + appScale() + ')' }">
        <!-- start 标题模块 -->
        <div class="home-title-module">
          <div class="home-title">
            欢迎使用
            <div class="home-title-significance">打字通</div>
            <img
              class="home-title-icon"
              src="@/assets/images/home-title-icon.png"
            />
          </div>
          <div class="home-subheading">零基础小白入门，轻松学会打字技巧</div>
        </div>
        <!-- end 标题模块 -->
        <!-- start 分隔模块 -->
        <div class="separate-module"></div>
        <!-- end 分隔模块 -->
        <!-- start 内容模块 -->
        <div class="content-module">
          <div
            class="menu-list"
            v-for="(item, index) in menuList"
            :key="index"
            @click="skip(item.path, index)"
          >
            <img class="menu-list-img" :src="item.imageUrl" />
            <div class="menu-list-info">
              <div class="menu-list-title">{{ item.title }}</div>
              <div class="menu-list-conent">{{ item.content }}</div>
            </div>
            <div class="recommend-label" v-if="item.recommend">入门推荐</div>
          </div>
        </div>
        <!-- end 内容模块 -->
        <!-- <LoginPopupVue
        :open="open"
        @close="open = false"
        @onloadUser="onloadUser"
      ></LoginPopupVue> -->
        <WeChatLogin
          :open="wxOpen"
          @close="wxOpen = false"
          @wxLoginOk="wxLoginOk"
        ></WeChatLogin>
        <!-- <MembersBuy :open="false" @close="false"></MembersBuy> -->
      </div>
    </div>
  </div>
  <!-- end 打字通首页-->
</template>

<script>
import LoginPopupVue from "@/components/LoginPopup.vue";
import WeChatLogin from "@/components/WeChatLogin.vue";
export default {
  name: "Home",
  components: {
    LoginPopupVue,
    WeChatLogin,
  },
  inject: ["appScale"],
  data() {
    return {
      // 是否打开弹窗
      // open: false,
      // 微信弹窗
      wxOpen: false,
      // 登录状态
      isLogin: false,
      // 微信是否登录
      isWxLogin: false,
      // 菜单数据
      menuList: [
        {
          imageUrl: require("@/assets/images/getting-started-icon.png"),
          title: "新手入门",
          content: "打字通是用于电脑初学者练习打字，熟悉键盘技巧的软件。",
          recommend: true,
          path: "/newArticle/knowKeyboard",
        },
        {
          imageUrl: require("@/assets/images/english-typewriting-icon.png"),
          title: "英文打字",
          content:
            "提高英文打字速度，平时的指法训练中，要求坐姿端正，指法正确。",
          recommend: false,
          path: "/englishTypewriting/index",
        },
        {
          imageUrl: require("@/assets/images/pinyin-typing-icon.png"),
          title: "拼音打字",
          content: "新手在初期使用拼音打字时，养成良好习惯，尽量将字拼完。",
          recommend: false,
          path: "/pinyinTyping/index",
        },
        {
          imageUrl: require("@/assets/images/typing-game.png"),
          title: "打字游戏",
          content: "初学者可以根据自己的水平设置游戏难度，逐步提高打字速度。",
          recommend: false,
          path: "/typingGame/index",
        },
      ],
    };
  },
  created() {
    // 加载登录用户数据
    // localStorage.removeItem("wxUserInfo", null);
    // localStorage.removeItem("token", null);
    //localStorage.removeItem("loginData");
  },
  methods: {
    // 跳转页面
    skip(path, index) {
      // if (index != 0 && !this.isWxLogin) {
      //   this.wxOpen = true;
      //   return;
      // }
      // if (index != 0 && !this.isLogin) {
      //   this.open = true;
      //   return;
      // }
      this.$router.push(path);
    },
    // 得到用户信息
    getUserInfo() {
      this.isLogin = true;
    },
    // 加载用户数据
    onloadUser() {
      setTimeout(() => {
        this.$refs.customHead.onloadUser();
      }, 200);
    },
    // 微信登录OK
    wxLoginOks() {
      this.isWxLogin = true;
    },
    // 更新数据
    wxLoginOk() {
      setTimeout(() => {
        this.$refs.customHead.onloadWxUser();
        this.$refs.customHead.isWhether();
      }, 200);
    },
    // 检查软件
    reloadVipInfo() {
      this.$refs.customHead.isWhether();
    },
    // 更新数据
    withdrawAccount() {
      this.isWxLogin = false;
      this.$emit("withdrawAccount");
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  flex-flow: column;
  justify-content: center;

  .home-title-module {
    .home-title {
      font-size: 40px;
      color: #535353;
      display: flex;
      position: relative;
      justify-content: center;
      .home-title-significance {
        margin-left: 18px;
        font-size: 40px;
        color: #fe8000;
      }
      .home-title-icon {
        width: 30px;
        height: 17px;
        position: absolute;
        top: 0;
        right: -30px;
      }
    }
    .home-subheading {
      margin-top: 7px;
      font-size: 16px;
      font-weight: 400;
      color: #979797;
      text-align: center;
    }
  }

  .separate-module {
    margin-top: 30px;
    width: 748px;
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.1607843137254902);
  }

  .content-module {
    margin-top: 40px;
    display: flex;
    flex-wrap: wrap;
    width: 840px;
    justify-content: space-between;
    box-sizing: border-box;
    .margin-interval {
      margin-left: 20px;
    }
    .recommend-label {
      width: 62px;
      height: 24px;
      background: #ff4600;
      border-radius: 6px 0px 6px 0px;
      font-size: 12px;
      font-weight: 400;
      color: #ffffff;
      position: absolute;
      right: 0px;
      line-height: 24px;
      text-align: center;
      top: -12px;
    }
    .menu-list {
      box-sizing: border-box;
      padding: 33px 38px 33px 20px;
      background: linear-gradient(180deg, #ffffff 0%, #f4f6f9 100%);
      &:hover {
        box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.1607843137254902);
      }
      border: 1px solid #c8d1d8;
      border-radius: 4px 4px 4px 4px;
      cursor: pointer;
      margin-bottom: 20px;
      display: flex;
      width: 410px;
      position: relative;
      .menu-list-img {
        width: 122px;
        height: 84px;
      }
      .menu-list-info {
        margin-left: 10px;
        width: 220px;
        .menu-list-title {
          font-size: 18px;
          font-weight: bold;
          color: #000000;
          text-align: left;
        }
        .menu-list-conent {
          margin-top: 14px;
          text-align: left;
          font-size: 14px;
          font-weight: 400;
          color: #000000;
          line-height: 22px;
        }
      }
    }
  }
}
</style>
